/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Utility class for SideBar component
 *
 * @author Dmitry Okunev
 * @version 1.2.0
 * @since 1.1.0
 */

export const SIDE_BAR_SELECT_ALL_ITEM = 0;
